import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Calendar, 
  Users, 
  Shield, 
  Menu
} from 'lucide-react';

const MobileBottomNav = ({ onMenuToggle }) => {
  const location = useLocation();
  
  const navItems = [
    { icon: LayoutDashboard, label: 'Accueil', path: '/dashboard' },
    { icon: Calendar, label: 'Planning', path: '/dashboard/planning' },
    { icon: Users, label: 'Agents', path: '/dashboard/agents' },
    { icon: Shield, label: 'Rondes', path: '/dashboard/rondes' },
    { icon: Menu, label: 'Menu', path: null },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-xl border-t border-white/10 pb-safe lg:hidden" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around px-2 py-1.5">
        {navItems.map((item) => {
          if (item.path === null) {
            return (
              <button
                key="menu"
                onClick={onMenuToggle}
                className="flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg text-slate-400 active:text-cyan-400 transition-colors"
                data-testid="bottom-nav-menu"
              >
                <item.icon className="w-5 h-5" />
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            );
          }

          const isActive = item.path === '/dashboard' 
            ? location.pathname === '/dashboard'
            : location.pathname.startsWith(item.path);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg transition-colors ${
                isActive ? 'text-cyan-400' : 'text-slate-400 active:text-cyan-400'
              }`}
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
            >
              <item.icon className={`w-5 h-5 ${isActive ? 'drop-shadow-[0_0_6px_rgba(6,182,212,0.5)]' : ''}`} />
              <span className="text-[10px] font-medium">{item.label}</span>
              {isActive && <div className="absolute -bottom-0 w-6 h-0.5 bg-cyan-400 rounded-full" />}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
